import Vue from 'vue';
import { gsap, Power4 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from "../gsap-bonus/SplitText";

gsap.registerPlugin(ScrollTrigger);

Vue.component('footer-component', {
    data() {
        return {

        };
    },

    mounted() {
        EventBus.$on('page-transition-enter-complete', this.init);
    },

    methods: {
        init() {
            const element = document.querySelector('.footer');
            element.classList.remove('footer--reveal');

            gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: "top 88%",
                    onEnter: () => {
                        element.classList.add('footer--reveal');
                    }
                },
            });

            const otherElements = [...document.querySelectorAll('.footer .a-ot-reveal--footer')];
            for (let index = 0; index < otherElements.length; index++) {
                const otherElement = otherElements[index];
                otherElement.classList.remove('--reveal');
                gsap.timeline({
                    scrollTrigger: {
                        trigger: otherElement,
                        start: "top 100%",
                        onEnter: () => {
                            otherElement.classList.add('--reveal');
                        }
                    },
                });
            }

            this.splitTitle();
        },

        splitTitle() {
            console.log('Splitting footer title');
            const elements = [...document.querySelectorAll('.split-title--footer')];

            for (let index = 0; index < elements.length; index++) {
                const element = elements[index];

                gsap.set(element, {"box-sizing":"border-box"});
                let chars = [...element.querySelectorAll('.char')];
                let lines = [...element.querySelectorAll('.line')];

                if (!element.dataset.scrollIndex) {
                    const splitLines = new SplitText(element, { type: 'lines,chars', linesClass: 'line', charsClass: 'char' });
                    chars = splitLines.chars;
                    lines = splitLines.lines;
                    element.dataset.scrollIndex = index;
                }

                gsap.set(chars, { opacity: 0, y: '100%', transformOrigin: 'bottom center' });
                gsap.set(element, { autoAlpha: 1 });

                for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
                    const line = lines[lineIndex];
                    gsap.to(line.children, {
                        scrollTrigger: {
                            trigger: element,
                            start: 'top 88%',
                            once: true,
                        },
                        y: '0%',
                        duration: 1,
                        stagger: 0.06,
                        ease: Power4.easeOut,
                        opacity: 1,
                        onComplete: () => {
                            // mySplitText.revert();
                        }
                    });
                }
            }
        },
    },
});